export default class Carousels {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Carousels;
		self.attachEvents();
	}

	static initCarousel($carousel) {
		const self = new Carousels;
		self.attachSlick($carousel);
	}

	attachEvents() {
		const self = this;

		$('.js-carousel').each(function(){
			self.attachSlick($(this));
		});

		$(document).on('click', '.js-carousel-go-to-slide', function(e) {
			e.preventDefault();
			self.goToSlide($(this).parents('.js-carousel'), $(this).data('slide'));
		});
	}

	attachSlick($carousel) {
		const self = this;

		if ($carousel.hasClass('slick-initialized')) {
			return;
		}

		if ($carousel.data('slick-initial-slide')) {
			$carousel.on('init', function(event, slick, currentSlide, nextSlide) {
				self.lazyLoadImages($(this));
			});
		}

		$carousel.slick({
	        autoplay        : $carousel.data('slick-autoplay') || false,
	        autoplaySpeed   : $carousel.data('slick-autoplay-speed') || 4000,
	        speed           : $carousel.data('slick-speed') || 600,
	        slidesToShow    : $carousel.data('slick-slides-to-show') || 3,
	        slidesToScroll  : $carousel.data('slick-slides-to-scroll') || 3,
	        dots            : $carousel.data('slick-dots') || false,
	        arrows          : $carousel.data('slick-arrows') || false,
	        fade            : $carousel.data('slick-fade') || false,
	        centerMode      : $carousel.data('slick-center-mode') || false,
	        centerPadding   : $carousel.data('slick-center-mode') || '30px',
	        useCSS          : $carousel.data('slick-use-css') || false,
	        swipe           : $carousel.data('slick-swipe') || true,
	        pauseOnHover    : $carousel.data('slick-pause-on-hover') || false,
	        pauseOnFocus    : $carousel.data('slick-pause-on-hover') || false,
	        vertical        : $carousel.data('slick-vertical') || false,
	        verticalSwiping : $carousel.data('slick-vertical') || false,
	        asNavFor 		: $carousel.data('slick-as-nav-for') || false,
	        infinite        : $carousel.data('slick-infinite') || true,
	        initialSlide	: $carousel.data('slick-initial-slide') || 0,
	        appendDots		: ($carousel.data('slick-append-controls') ? $carousel.next('.slick-controls').find('.slick-dots-wrapper') : $carousel),
	        prevArrow		: ($carousel.data('slick-append-controls') ? $carousel.next('.slick-controls').find('.slick-prev') : '<a href="#" class="slick-arrow slick-prev" aria-label="Previous Slide"></a>'),
	        nextArrow		: ($carousel.data('slick-append-controls') ? $carousel.next('.slick-controls').find('.slick-next') : '<a href="#" class="slick-arrow slick-next" aria-label="Next Slide"></a>'),
	        lazyLoad        : 'ondemand',
	        adaptiveHeight  : $carousel.data('slick-adaptive-height') || false,
	        responsive      : $carousel.data('slick-responsive') || [
	            {
	                breakpoint: 1200,
	                settings: {
	                	"dots": true,
	                	"arrows": true,
	                    slidesToShow: 2,
	                    slidesToScroll: 2
	                }
	            },
	            {
	                breakpoint: 767,
	                settings: {
	                	"dots": true,
	                	"arrows": true,
	                    slidesToShow: 1,
	                    slidesToScroll: 1
	                }
	            },
	        ]
	    });

		// Ensuring any lazy loaded images in slick carousel are visible
		// Ensuring any lazy loaded images in slick carousel are visible
		$carousel.on('afterChange', function(event, slick, currentSlide, nextSlide) {
			self.lazyLoadImages($(this));
		});

		$carousel.on('setPosition', function(event, slick, currentSlide, nextSlide) {
			self.showHideControls($carousel);
		});
	}

	showHideControls($carousel) {
		const self = this;

		if ($carousel.next('.slick-controls').find('.slick-dots-wrapper').is(':empty')){
			$carousel.next('.slick-controls').hide();
		} else {
			$carousel.next('.slick-controls').show();
		}
	}

	goToSlide($carousel, slide) {
		const self = this;

		$carousel.slick('slickGoTo', slide);
	}

	lazyLoadImages($carousel) {
		const self = this;

		$carousel.find('.slick-slide.slick-active').each(function(){
			let $slide = $(this);

			self.lazyLoadImagesInSlide($slide);
		});

		let $slide = $carousel.find('.slick-slide.slick-active:last');
		self.lazyLoadImagesInSlide($slide);
	}

	lazyLoadImagesInSlide($slide) {
		const self = this;

		var $image = $slide.find('[data-lazy-img]'),
			image = $image.get()[0];

		if(typeof image != 'undefined') {
			let elementName = image.tagName.toLowerCase(),
				imgSrc = image.getAttribute('data-lazy-img');

			if(typeof imgSrc != 'undefined' && imgSrc.length > 0){
				if (elementName == 'img') {
					image.src = imgSrc;
				} else {
					image.style.backgroundImage = 'url(' + imgSrc + ')';
				}
			}
		}

		return self;
	}
}
